

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { ProvinceSetup } from "../../components/ProvinceSetup";


export const ProvinceSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Province Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Province Setup", navigateTo: "/province/setup" }
      ]}
      mainContents={<ProvinceSetup />}
    />
  );
};
